module.exports = __webpack_public_path__ + "static/media/Variation Theme USDC.2a7a44d4.png";